import { Divider, Typography, WithStyles } from "@material-ui/core";
import * as React from "react";
import { styles } from "./AddressesForm.styles";
import { BlueButton } from "../../Buttons/BlueButton";
import UserDetailsModel from "../../../../models/user/UserDetailsModel";
import { SingleAddressForm } from "./SingleAddressForm";
import { withStyles } from "@material-ui/core/styles";
import AddressModel from "../../../../models/user/AddressModel";
import { useTranslation } from "react-i18next";


export interface IAddressesFormProps extends WithStyles<typeof styles> {
    userDetails: UserDetailsModel
    onSave: any
}

const AddressesFormPure: React.FunctionComponent<IAddressesFormProps> = ({
                                                                             onSave,
                                                                             userDetails,
                                                                             classes
                                                                         }: IAddressesFormProps) => {


    const [details, setDetails] = React.useState({
        billingAddress: userDetails.billingAddress,
        billingAddressEdit: false,
        deliveryAddress: userDetails.deliveryAddress,
        deliveryAddressEdit: false,
    });

    const handleSave = (type) => {
        userDetails[type] = details[type];

        onSave(userDetails);
    };

    const handleAddAddress = (type) => {
        setDetails({
            ...details,
            [type]: new AddressModel(),
            [type + "Edit"]: true,
        });
    };

    const handleEditMode = (type) => {
        const propName = type + "Edit";
        setDetails({
            ...details,
            [propName]: !details[propName]
        });
    };

    const {t} = useTranslation();

    return <>


        {
            details.billingAddress == null
                ? <BlueButton onClick={() => handleAddAddress("billingAddress")}>{t("userManagement.addressesForm.addBillingAddress")}</BlueButton>
                : <>
                    <Typography className={classes.addressTitle} variant={"h6"}>{t("userManagement.addressesForm.billingAddress")}</Typography>
                    <SingleAddressForm onSave={() => handleSave("billingAddress")} address={details.billingAddress}
                                       editMode={details.billingAddressEdit}
                                       handleEditMode={() => handleEditMode("billingAddress")} />
                </>
        }
        <br />
        <br />

        {
            details.deliveryAddress == null
                ? <BlueButton onClick={() => handleAddAddress("deliveryAddress")}>{t("userManagement.addressesForm.addDeliveryAddress")}</BlueButton>
                : <>
                    <Divider className={classes.divider} />
                    <Typography className={classes.addressTitle} variant={"h6"}>{t("userManagement.addressesForm.deliveryAddress")}</Typography>

                    <SingleAddressForm onSave={() => handleSave("deliveryAddress")} address={details.deliveryAddress}
                                       editMode={details.deliveryAddressEdit}
                                       handleEditMode={() => handleEditMode("deliveryAddress")} />
                </>
        }


        <br />
    </>;
};

export const AddressesForm = withStyles(styles)(AddressesFormPure);
